import Swiper from 'swiper'
import { Navigation, Pagination, Parallax } from 'swiper/modules'

Swiper.use([Navigation, Pagination, Parallax])

const initSwiper = block => {
  try {
    const swiper = block.querySelector('.swiper--optin-start')
    const pagination = block.querySelector('.swiper-pagination')
    new Swiper(swiper, {
      slidesPerView: 1,
      spaceBetween: 0,
      parallax: true,
      centeredSlides: true,
      pagination: {
        el: pagination,
        clickable: false
      }
    })
  } catch (e) {
    console.error('Cannot init swiper for opt-in start ', e)
  }
}

const init = () => {
  const blocksOnPage = Array.from(document.querySelectorAll('.opt-in__swiper-container'))

  if (!blocksOnPage) return

  blocksOnPage.forEach(block => initSwiper(block))
}
export default init
